<div
  [ngStyle]="{'height.px': topSearchSpacerHeight()}"
  class="block"
>
  <ng-content select="[topwidget]"></ng-content>
</div>
